const isSmoothScrollSupported = ((document || {}).documentElement || {}).style
  ? 'scrollBehavior' in document.documentElement.style
  : false;

export const toTop = () => {
  if (isSmoothScrollSupported) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  } else {
    window.scrollTo(0, 0);
  }
};


export const toElement = (element) => {
  if (!element) return;
  const top = element.getBoundingClientRect().top + window.pageYOffset;
  if (isSmoothScrollSupported) {
    document.documentElement.style.scrollSnapType = 'none';
    window.scrollTo({ top, left: 0, behavior: 'smooth' });
    setTimeout(() => {
      document.documentElement.style.scrollSnapType = '';
    }, 800);
  } else {
    window.scrollTo(0, top);
  }
};

export default {
  toTop,
  toElement
};



// WEBPACK FOOTER //
// ./src/utils/scroll.js